/**
 * 撤销/重做历史栈（P0-10）——纯数组逻辑，与 store 解耦、可离线测。
 *
 * 约定：present 即 store 里的 project（单一真源，这里不重复存 present），
 * 只维护 past/future 两个快照栈。三个纯函数供 store 调用：
 *  · pushPast：一次编辑前把旧 project 压入 past；coalesce=true 表示"与上一步合并"
 *    （拖拽/滑杆的连续帧只算一步，不新增 past）；
 *  · undoStep / redoStep：在 past/present/future 间搬移，返回 null 表示无可撤销/重做。
 * 时间/键的合并判定放在 store（需要 Date.now 与"改的是谁"），这里只吃一个 coalesce 布尔。
 */

export const HISTORY_LIMIT = 100;
/** 同一目标在此毫秒窗内的连续修改合并为一步（拖拽/滑杆连续帧） */
export const COALESCE_MS = 500;

export function pushPast<T>(past: T[], present: T, coalesce: boolean, limit = HISTORY_LIMIT): T[] {
  if (coalesce) {
    return past;
  }
  return [...past, present].slice(-limit);
}

export interface StepResult<T> {
  present: T;
  past: T[];
  future: T[];
}

export function undoStep<T>(past: T[], present: T, future: T[], limit = HISTORY_LIMIT): StepResult<T> | null {
  if (past.length === 0) {
    return null;
  }
  const previous = past[past.length - 1] as T;
  return {
    present: previous,
    past: past.slice(0, -1),
    future: [present, ...future].slice(0, limit),
  };
}

export function redoStep<T>(past: T[], present: T, future: T[], limit = HISTORY_LIMIT): StepResult<T> | null {
  if (future.length === 0) {
    return null;
  }
  const next = future[0] as T;
  return {
    present: next,
    past: [...past, present].slice(-limit),
    future: future.slice(1),
  };
}
